// STICKY FILTER
window.addEventListener("load", function() {
  const filterContainer = document.querySelector(".sticky-facets-container");
  const filter = this.document.querySelector(".facets-container");

  if(filterContainer) {
    const header = document.querySelector("sticky-header.header-wrapper");

    const headerFilterContainer = filterContainer;

    header.appendChild(headerFilterContainer);

    window.addEventListener('scroll', function() {
      if(filter.getBoundingClientRect().bottom <= header.getBoundingClientRect().bottom) {
        if(!headerFilterContainer.classList.contains("active")) {
          /*headerFilterContainer.innerHTML = filterContainer.innerHTML;
          filterContainer.style.height = filterContainer.getBoundingClientRect().height + "px";
          filterContainer.innerHTML = " ";*/

          headerFilterContainer.classList.add('active');
        }
      }
      else {
        if(headerFilterContainer.classList.contains("active")) {
          /*filterContainer.innerHTML = headerFilterContainer.innerHTML;
          headerFilterContainer.innerHTML = " ";*/
          headerFilterContainer.classList.remove('active');
        }
      }
    });
  }
});

class RecentlyViewedProducts extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.loadProducts();
  }

  async loadProducts() {
    const section = this.closest(".shopify-section");
    const url = `${Shopify.routes.root}search?type=product&q=${this.getSearchQueryString()}&section_id=${section.id.replace("shopify-section-", "")}`;
    const response = await fetch(url, {priority: "low"});
    const tempDiv = new DOMParser().parseFromString(await response.text(), "text/html");
    const recentlyViewedProductsElement = tempDiv.querySelector("recently-viewed-products");

    if (recentlyViewedProductsElement.childElementCount > 0) {
      this.replaceChildren(...document.importNode(recentlyViewedProductsElement, true).childNodes);
    } else {
      section.remove();
    }
  }

  getSearchQueryString() {
    const items = new Set(JSON.parse(localStorage.getItem("theme:recently-viewed-products") || "[]"));
    if (this.hasAttribute("exclude-id")) {
      items.delete(parseInt(this.getAttribute("exclude-id")));
    }
    return Array.from(items.values(), (item) => `id:${item}`).slice(0, parseInt(this.getAttribute("products-count"))).join(" OR ");
  }
}

customElements.define("recently-viewed-products", RecentlyViewedProducts);

class ContentTabs extends HTMLElement {
  constructor() {
    super();

    this.tabsContainer = this.querySelector('.tabs-container');
    this.tabsList = this.tabsContainer.querySelector('ul');
    this.tabButtons = this.tabsList.querySelectorAll('a');
    this.tabPanels = this.querySelectorAll('.tab__panels > div');

    if (this.tabPanels.length === 0) {
      this.setAttribute('hidden', '');
      return;
    }

    this.init();
  }

  init() {
    this.tabsList.setAttribute('role', 'tablist');

    this.tabsList.querySelectorAll('li').forEach(li => { 
      li.setAttribute('role', 'presentation');
    });

    this.tabButtons.forEach((button, index) => {
      const relatedPanel = this.tabPanels[index];

      if (relatedPanel.innerHTML === '') {
        button.parentNode.classList.add('hidden');
      }
    }); 

    this.tabButtons.forEach((button, index) => {
      button.setAttribute('role', 'tab');

      if (index === 0) {
        button.setAttribute('aria-selected', 'true');
      } else {
        button.setAttribute('tabindex', '-1');
        this.tabPanels[index].setAttribute('hidden', '');
      }
    });

    this.tabPanels.forEach(panel => {
      panel.setAttribute('role', 'tabpanel');
      panel.setAttribute('tabindex', '0');
    });

    this.tabsContainer.addEventListener('click', event => {
      const clickedTab = event.target.closest('a');

      if (!clickedTab) return;

      event.preventDefault();

      this.activateTab(clickedTab);
    });

    this.tabsContainer.addEventListener('keydown', event => {
      switch(event.key) {
        case 'ArrowLeft':
          event.preventDefault();
          this.moveLeft();
          break;
        case 'ArrowRight':
          event.preventDefault();
          this.moveRight();
          break;
        case 'Home':
          event.preventDefault();
          this.activateTab(this.tabButtons[0]);
          break;
        case 'End':
          event.preventDefault();
          this.activateTab(this.tabButtons[this.tabButtons.length - 1]);
          break;
      }
    });
  }

  moveLeft() {
    const activeTab = this.tabsList.querySelector('[aria-selected="true"]');
    const previousTab = activeTab.parentNode.previousElementSibling;

    if (!previousTab) {
      this.activateTab(this.tabButtons[this.tabButtons.length - 1]);
    } else {
      this.activateTab(previousTab.querySelector('a'));
    }
  }

  moveRight() {
    const activeTab = this.tabsList.querySelector('[aria-selected="true"]');
    const nextTab = activeTab.parentNode.nextElementSibling;

    if (!nextTab) {
      this.activateTab(this.tabButtons[0]);
    } else {
      this.activateTab(nextTab.querySelector('a'));
    }
  }

  activateTab(clickedTab) {
    const activePanelId = clickedTab.getAttribute('href');
    const activePanel = this.querySelector(activePanelId);

    this.tabButtons.forEach(button => {
      button.setAttribute('aria-selected', 'false');
      button.classList.remove('button--primary', 'button--active');
      button.classList.add('button--secondary');
      button.setAttribute('tabindex', '-1');
    });

    this.tabPanels.forEach(panel => {
      panel.setAttribute('hidden', '');
    });

    activePanel.removeAttribute('hidden');
    activePanel.querySelectorAll('flickity-carousel').forEach(carousel => {
      carousel.flickity.resize();
    });

    clickedTab.setAttribute('aria-selected', 'true');
    clickedTab.classList.remove('button--secondary');
    clickedTab.classList.add('button--primary', 'button--active');
    clickedTab.setAttribute('tabindex', '0');
    clickedTab.focus();
  }
}

customElements.define('content-tabs', ContentTabs);

/* --- Wishlist --- */
var Wishlist = class extends HTMLElement {
  constructor() {
    super();

    this.wishlist = window.wishlist || [];
    this.currentPage = 0;
    this.limit = Number(this.dataset?.limit) || 48;
    this.emptyMessage = this.querySelector('.wishlist__empty_message');
    this.loadMessage = this.querySelector('.wishlist__loading');

    this.loadWishlist();
  }

  loadMore() {
    this.observer.unobserve(this.observerItem);
    setTimeout(() => {
      this.querySelectorAll('.wishlist__loading').forEach((item) => {
        item.remove();
      });

      this.loadWishlist();
    }, 500);
  }

  initIntersection() {
    this.observerItem = this.querySelector('.wishlist__loading');
    console.log(this.observerItem);

    if (this.observerItem !== null) {
      this.observer = new IntersectionObserver((entries) => {
        if (entries[0].intersectionRatio <= 0) {
          return;
        }

        this.loadMore();
      }, {
        root: null,
        rootMargin: '0px',
        threshold: 0.5
      });
      this.observer.observe(this.observerItem);
    } else {
      this.observer = null;
    }
  }

  appendLoader() {
    this.querySelectorAll('.wishlist__loading').forEach((item) => {
      item.remove();
    });

    this.innerHTML += `
      <div class="section-stack wishlist__loading">
        <div class="section-header justify-self-center text-center">
          <h3 class="h4">${ window.themeVariables.strings.wishlistLoading }</h4>
        </div>
      </div>`;
    setTimeout(this.initIntersection.bind(this), 200);
  }

  async loadWishlist() {
    const currentOffset = this.currentPage * this.limit;

    if (this.wishlist.length > currentOffset) {
      const currentItems = this.wishlist.slice(currentOffset, currentOffset + this.limit);

      if (currentItems.length === 0) {
        this.querySelectorAll('.wishlist__loading').forEach((item) => {
          item.remove();
        });

        return;
      }

      const query = currentItems.map((item) => {
        return `id:${ item }`;
      }).join(' OR ');
      const responseText = await (await fetch(`${ Shopify.routes.root }search?section_id=wishlist&type=product&q=${ query }`, {
        credentials: 'same-origin',
        method: 'GET'
      })).text();
      const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');

      this.querySelector('.product-list').innerHTML += responseHTML.querySelector('.product-list').innerHTML;

      this.currentPage++;

      if (this.wishlist.length > this.currentPage * this.limit) {
        this.appendLoader();
      }
    } else if (this.wishlist.length === 0 && this.emptyMessage) {
      this.querySelector('.product-list').innerHTML = '';
      this.emptyMessage.removeAttribute('hidden');
    }
  }
}

window.customElements.define('x-wishlist', Wishlist);

var WishlistAdd = class extends HTMLElement {
  constructor() {
    super();

    this.wishlist = window.wishlist || [];
    this.icon = this.querySelector('.icon-wishlist');
    this.filledIcon = this.querySelector('.icon-wishlist-filled');
    this.productId = this.dataset.productId;
    this.emptyMessage = document.querySelector('.wishlist__empty_message');

    this.checkIcon();
    this.addEventListener('click', (event) => this.addToOrRemoveFromWishlist(event));
  }

  addToOrRemoveFromWishlist(e) {
    /* In case we embed the icon within an anchor, don't redirect the user */
    e.preventDefault();

    console.log(this.icon.getAttribute('aria-hidden'))
    if (this.icon.getAttribute('aria-hidden') !== 'true') {
      this.addToWishlist();
    } else {
      this.removeFromWishlist();
    }
  }

  checkIcon() {
    if (this.wishlist.length === 0) {
      return;
    }

    if (this.productId === null) {
      return;
    }

    if (this.icon.getAttribute('aria-hidden') === 'true') {
      return;
    }

    if (this.wishlist.includes(this.productId)) {
      this.icon.setAttribute('aria-hidden', 'true');
      this.filledIcon.setAttribute('aria-hidden', 'false');
    }
  }

  addToWishlist() {
    console.log('add');
    this.wishlist = window.wishlist || [];

    if (this.wishlist.includes(this.productId)) {
      return;
    }

    this.wishlist.push(this.productId);
    localStorage.setItem('wishlist', JSON.stringify(this.wishlist));
    window.wishlist = this.wishlist;

    this.icon.setAttribute('aria-hidden', 'true');
    this.filledIcon.setAttribute('aria-hidden', 'false');

    /* Detail is passed for future opportunities, such as GTM */
    document.dispatchEvent(new CustomEvent('wishlist:changed', {
      detail: {
        elem: this,
        status: 'added'
      }
    } ));
  }

  removeFromWishlist() {
    console.log('remove');
    this.wishlist = window.wishlist || [];

    if (this.wishlist.length === 0) {
      return;
    }

    if (this.productId === null) {
      return;
    }

    if (!this.wishlist.includes(this.productId)) {
      return;
    }

    this.wishlist.splice(this.wishlist.indexOf(this.productId), 1);
    localStorage.setItem('wishlist', JSON.stringify(this.wishlist));
    window.wishlist = this.wishlist;

    this.icon.setAttribute('aria-hidden', 'false');
    this.filledIcon.setAttribute('aria-hidden', 'true');

    /* Detail is passed for future opportunities, such as GTM */
    document.dispatchEvent(new CustomEvent('wishlist:changed', {
      detail: {
        elem: this,
        status: 'removed'
      }
    } ));
  }
}

window.customElements.define('wishlist-add', WishlistAdd);

var WishlistRemove = class extends HTMLElement {
  constructor() {
    super();

    this.productId = this.dataset.productId;
    this.emptyMessage = document.querySelector('.wishlist__empty_message');

    this.addEventListener('click', this.removeFromWishlist.bind(this));
  }

  removeFromWishlist(e) {
    /* In case we embed the icon within an anchor, don't redirect the user */
    e.preventDefault();

    this.wishlist = window.wishlist || [];

    if (this.productId === null) {
      return;
    }

    this.wishlist.splice(this.wishlist.indexOf(this.productId), 1);
    localStorage.setItem('wishlist', JSON.stringify(this.wishlist));
    window.wishlist = this.wishlist;

    this.closest('.product-card').classList.add('is-removing');

    setTimeout(() => {
      this.closest('.product-card').remove();
    }, 500);

    if (this.wishlist.length === 0 && this.emptyMessage !== null) {
      setTimeout(() => {
        /* The remove button is only being present on the Wishlist page, thus selecting x-wishlist will never return null */
        document.querySelector('x-wishlist .product-list').innerHTML = '';
        this.emptyMessage.removeAttribute('hidden');
      }, 500);
    }

    /* Detail is passed for future opportunities, such as GTM */
    document.dispatchEvent(new CustomEvent('wishlist:changed', {
      detail: {
        elem: this,
        status: 'removed'
      }
    } ));
  }
}

window.customElements.define('wishlist-remove', WishlistRemove);

var WishlistCount = class extends HTMLElement {
  constructor() {
    super();

    this.inner = this.querySelector('span');
    this.wishlist = window.wishlist || [];

    this.updateCount();
    document.addEventListener('wishlist:changed', this.updateCount.bind(this));
  }

  updateCount() {
    if (this.wishlist.length === 0) {
      if (this.inner !== null) {
        this.inner.innerText = '';
      }

      this.classList.remove('is-visible');

      return;
    }

    if (this.inner !== null) {
      this.inner.innerText = this.wishlist.length;
    }

    this.classList.add('is-visible');
  }
}

window.customElements.define('wishlist-count', WishlistCount);

var SubCollections = class extends HTMLElement {
  constructor() {
    super();

    this.seeMoreButton = this.querySelector('.subcollections--see-more');
    if (this.seeMoreButton) {
      this.seeMoreButton.addEventListener('click', this.remove.bind(this));
    }
  }

  remove() {
    this.classList.remove('subcollections--limited');
    this.seeMoreButton.remove();
  }
}

window.customElements.define('sub-collections', SubCollections);

var FilterCollapser = class extends HTMLElement {
  constructor() {
    super();

    this.filters = document.querySelector('#main-collection-filters,#main-search-filters');
    this.filterBlocks = document.querySelector('#FacetBlockFiltersForm');

    this.label = this.querySelector('.filter-collapser--label');
    this.isOpen = this.hasAttribute('data-open');

    this.productGrid = document.querySelector('#product-grid');

    this.showText = this.getAttribute('data-show');
    this.hideText = this.getAttribute('data-hide');

    if (!this.showText) {
      this.showText = "Show Filters"
    }
    
    if (!this.hideText) {
      this.hideText = "Hide Filters"
    }

    this.addEventListener('click', this._clicked.bind(this));
  }

  _clicked() {
    this.productGrid = document.querySelector('#product-grid');
    if (this.isOpen) {
      this.filters.classList.add('filters--hidden');
      //this.filterBlocks.setAttribute('aria-hidden', 'true');

      this.removeAttribute('data-open');
      this.label.innerText = this.showText;
      this.productGrid.classList.remove('grid--3-col-desktop');
    } else {
      this.filters.classList.remove('filters--hidden');
      //this.filterBlocks.setAttribute('aria-hidden', 'false');

      this.setAttribute('data-open', '');
      this.label.innerText = this.hideText;
      this.productGrid.classList.add('grid--3-col-desktop');
    }

    this.isOpen = !this.isOpen;
  }
}

window.customElements.define('filter-collapser', FilterCollapser);

var CheckboxSync = class extends HTMLElement {
  constructor() {
    super();

    this.original = this.querySelector('input');
    this.inputs = document.querySelectorAll(`input[name="${this.original.name}"][value="${this.original.value}"]`);
    
    for (const input of this.inputs) {
      input.addEventListener('click', this._changed.bind(this, input));
    }
  }

  _changed(clickedInput) {
    console.log('changed');
    for (var input of this.inputs) {
      input.checked = clickedInput.checked;
    }
  }
}

window.customElements.define('checkbox-sync', CheckboxSync);

var CompareScrollBar = class extends HTMLElement {
  constructor() {
    super();

    this.section = document.getElementById(this.dataset['id']);
    this.bar = this.querySelector('.compare-scroll-bar--bar');
    this.barWidth = parseInt(this.dataset['width']);
    this.sectionScrollLeft = 0;
    this.pressed = false;

    this.boundMove = this._move.bind(this);
  }

  connectedCallback() {
    this.section.addEventListener('scroll', this._scroll.bind(this));
    this.bar.addEventListener('mousedown', this._down.bind(this));
    document.addEventListener('mouseup', this._up.bind(this));
    window.addEventListener('resize', () => {
      this._scroll();
    });
    this._scroll();
  }

  _max() {
    return this.section.scrollWidth - this.section.clientWidth;
  }

  _progress() {
    return this.section.scrollLeft / this._max();
  }

  _scroll() {
    this.style.setProperty('--progress', this._progress());

    if (!this.pressed) {
      this.sectionScrollLeft = this.section.scrollLeft;
    }
  }

  _down() {
    this.pressed = true;
    document.addEventListener('mousemove', this.boundMove);
  }

  _up() {
    this.pressed = false;
    document.removeEventListener('mousemove', this.boundMove);
  }

  _move(e) {
    if (!this.pressed) return;

    const width = this.clientWidth;
    const area = width - this.barWidth;
    
    const movementProgress = e.movementX / area * this._max();
    this.sectionScrollLeft += movementProgress;

    this.section.scrollLeft = this.sectionScrollLeft;

    this._scroll();
  }
}

window.customElements.define('compare-scroll-bar',  CompareScrollBar);

var PriceRangeSlider = class extends HTMLElement {
  constructor() {
    super();

    this.abortController = new AbortController();

    const rangeLowerBound = this.querySelector('input[type="range"]:first-child');
    const rangeHigherBound = this.querySelector('input[type="range"]:last-child');
    const textInputLowerBound = this.closest('price-range').querySelector('input[name="filter.v.price.gte"]');
    const textInputHigherBound = this.closest('price-range').querySelector('input[name="filter.v.price.lte"]');

    textInputLowerBound.addEventListener("change", (event) => {
      event.preventDefault();
      event.target.value = Math.max(Math.min(parseInt(event.target.value), parseInt(textInputHigherBound.value || event.target.max) - 1), event.target.min);
      rangeLowerBound.value = event.target.value;
      rangeLowerBound.closest('.price_range_group').style.setProperty("--range-min", `${parseInt(rangeLowerBound.value) / parseInt(rangeLowerBound.max) * 100}%`);
    }, { 
      signal: this.abortController.signal 
    });

    textInputHigherBound.addEventListener("change", (event) => {
      event.preventDefault();
      event.target.value = Math.min(Math.max(parseInt(event.target.value), parseInt(textInputLowerBound.value || event.target.min) + 1), event.target.max);
      rangeHigherBound.value = event.target.value;
      rangeHigherBound.closest('.price_range_group').style.setProperty("--range-max", `${parseInt(rangeHigherBound.value) / parseInt(rangeHigherBound.max) * 100}%`);
    }, { 
      signal: this.abortController.signal 
    });

    rangeLowerBound.addEventListener("change", (event) => {
      event.stopPropagation();
      textInputLowerBound.value = event.target.value;
      textInputLowerBound.dispatchEvent(new Event("change", { bubbles: true }));
    }, { 
      signal: this.abortController.signal 
    });

    rangeHigherBound.addEventListener("change", (event) => {
      event.stopPropagation();
      textInputHigherBound.value = event.target.value;
      textInputHigherBound.dispatchEvent(new Event("change", { bubbles: true }));
    }, { 
      signal: this.abortController.signal 
    });

    rangeLowerBound.addEventListener("input", (event) => {
      event.target.value = Math.min(parseInt(event.target.value), parseInt(textInputHigherBound.value || event.target.max) - 1);
      event.target.closest('.price_range_group').style.setProperty("--range-min", `${parseInt(event.target.value) / parseInt(event.target.max) * 100}%`);
      textInputLowerBound.value = event.target.value;
    }, { 
      signal: this.abortController.signal 
    });

    rangeHigherBound.addEventListener("input", (event) => {
      event.target.value = Math.max(parseInt(event.target.value), parseInt(textInputLowerBound.value || event.target.min) + 1);
      event.target.closest('.price_range_group').style.setProperty("--range-max", `${parseInt(event.target.value) / parseInt(event.target.max) * 100}%`);
      textInputHigherBound.value = event.target.value;
    }, { 
      signal: this.abortController.signal 
    });
  }

  disconnectedCallback() {
    this.abortController.abort();
  }
}

window.customElements.define("price-range-slider", PriceRangeSlider);

var HoverMenuSwitcher = class extends HTMLElement {
  constructor() {
    super();

    this.mainNavItems = this.querySelectorAll('#mega-menu-holder > li > simple-accordion');

    for (const navItem of this.mainNavItems) {
      const subNavItems = navItem.querySelectorAll('.left-nav > li');

      for (const subNavItem of subNavItems) {
        subNavItem.addEventListener('mouseenter', this._switch.bind(this, subNavItem));
      }
    }
  }

  _switch(subNavItem) {
    const currentIndex = subNavItem.getAttribute('data-index');
    const previousSelectedIndex = subNavItem.closest('.left-nav').getAttribute('data-selected');

    if (currentIndex === previousSelectedIndex) {
      return;
    }

    const target = subNavItem.closest('simple-accordion').querySelector(`.right-nav-wrapper[data-index="${currentIndex}"]`);
    const oldTarget = subNavItem.closest('simple-accordion').querySelector(`.right-nav-wrapper[data-index="${previousSelectedIndex}"]`);

    const contentTarget = subNavItem.closest('simple-accordion').querySelector(`.right-container-wrapper div:not(.right-nav-wrapper)[data-index="${currentIndex}"]`);
    const oldContentTarget = subNavItem.closest('simple-accordion').querySelector(`.right-container-wrapper div:not(.right-nav-wrapper)[data-index]:not(.hidden)`);

    if (target && oldTarget) {
      target.classList.remove('hidden')  
      oldTarget.classList.add('hidden');
    }

    if (contentTarget) {
      contentTarget.classList.remove('hidden');
    }
    if (contentTarget && oldContentTarget) {
      oldContentTarget.classList.add('hidden');
    }

    subNavItem.closest('.left-nav').setAttribute('data-selected', currentIndex);
  }
}

window.customElements.define('hover-menu-switcher', HoverMenuSwitcher);

var ReadMoreToggle = class extends HTMLElement {
  constructor() {
    super();
    
    this.target = this.previousElementSibling;

    this.boundToggleVisibility = this.toggleVisibility.bind(this);

    this.readMoreLabel = this.getAttribute('data-read-more');
    this.readLessLabel = this.getAttribute('data-read-less');

    if (!this.target) {
      this.remove();
      return;
    }
    this.enabled = this.target.classList.contains('clamp');

    this.addEventListener('click', this.boundToggleVisibility);
  }

  toggleVisibility() {
    if (this.target.classList.toggle('clamp')) {
      this.innerText = this.readMoreLabel;
    } else {
      this.innerText = this.readLessLabel;
    }
  }

  connectedCallback() {
    this.addEventListener('click', this.boundToggleVisibility);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.boundToggleVisibility);
  }


}
window.customElements.define('read-more-toggle', ReadMoreToggle);

var GiftWrapper = class extends HTMLElement {
  constructor() {
    super();
    
    this.data = null;
    this.opener = null;
    this.closers = [];
    this.modal = null;
    this.modalShade = null;
    this.wrapperCards = [];

    this.shouldSwap = this.hasAttribute('data-should-swap');

    this.boundOpen = this.open.bind(this);
    this.boundClose = this.close.bind(this);
    this.boundAddProduct = this.addProduct.bind(this);
  }

  connectedCallback() {
    const dataScript = this.querySelector('.gift-wrapper-data');
    if (dataScript) {
      try {
        this.data = JSON.parse(dataScript.innerHTML);
      }
      catch (ex) {
        console.error('Error in JSON')
      }
    }

    if (this.data === null) {
      console.error('Data is missing or could not be parsed, removing from DOM');
      this.remove();
      return;
    }

    this.opener = this.querySelector('.gift-wrapper--open');
    this.closers = this.querySelectorAll('.gift-wrapper--close');
    this.modal = this.querySelector('.gift-wrapper--modal');
    this.modalShade = this.querySelector('.gift-wrapper--modal-shade');
    this.wrapperCards = this.querySelectorAll('.gift-wrapper--card');

    this.opener.addEventListener('click', this.boundOpen);
    for (const closer of this.closers) {
      closer.addEventListener('click', this.boundClose);
    }
    for (const wrapperCard of this.wrapperCards) {
      wrapperCard.addEventListener('click', this.boundAddProduct);
    }
  }

  open() {
    this.modal.classList.remove('hidden');
    this.modalShade.classList.remove('hidden');
  }

  close() {
    this.modal.classList.add('hidden');
    this.modalShade.classList.add('hidden');
  }

  addProduct(e) {
    const card = e.target.closest('.gift-wrapper--card');
    const variantId = card.dataset.id;
    const variantTitle = card.dataset.title;

    if (this.shouldSwap) {
      const wrapperIds = this.data.wrapper_ids;
      document.querySelector('cart-drawer-items').swapOrAddGiftWrapper(variantId, variantTitle, wrapperIds);
    } else {
      document.querySelector('cart-drawer-items').addGiftWrapper(variantId, variantTitle);
    }

    this.close();
  }
}

window.customElements.define('gift-wrapper', GiftWrapper);

var TryOut = class extends HTMLElement {
  constructor() {
    super();

    this.textInput = this.querySelector('input[type="text"]');
    this.textContainer = this.querySelector('.try-out-media-text-holder');
    this.imageOptions = this.querySelectorAll('label');
    this.images = this.querySelectorAll('.try-out-media img');

    this.textInput.addEventListener('input', () => this.updateText());

    if (this.images.length === 0) {
      return;
    }

    for (const imageOption of this.imageOptions) {
      imageOption.addEventListener('click', (e) => this.updateImage(e));
    }
  }

  updateText() {
    this.textContainer.innerText = this.textInput.value;
  }

  updateImage(e) {
    const target = e.target.nodeName === 'INPUT' ? e.target : e.target.previousElementSibling;
    const targetIndex = target.getAttribute('data-position');

    for (const image of this.images) {
      if (image.getAttribute('data-position') !== targetIndex) {
        image.classList.add('hidden');

        continue;
      }

      image.classList.remove('hidden');
    }
  }
}

window.customElements.define('try-out', TryOut);

/* Modifying Line Item properties for Customily */
window.canvasBlob = null;

window.addEventListener('customily-app-will-load', () => {
  console.log('----------DEBUG---------');
  console.log('--Customily will load---');

  const productForm = document.querySelector('.product-form');

  if (!productForm) {
    return;
  }

  const innerForm = productForm.querySelector('form');

  const config = {
    attributes: false,
    childList: true,
    subtree: true
  };

  const callback = (mutationList) => {
    for (const mutation of mutationList) {
      if (mutation.type !== "childList") {
        continue;
      }

      for (const addedNode of mutation.addedNodes) {
        if (addedNode.nodeName !== 'INPUT') {
          continue;
        }

        if (addedNode.getAttribute('name') !== 'properties[_customily-preview]') {
          continue;
        }

        if (innerForm.querySelector('[name="properties[Bekijk je personalisatie perview ->]"]')) {
          innerForm.querySelector('[name="properties[Bekijk je personalisatie perview ->]"]').remove();
        }

        console.log('----------DEBUG---------');
        console.log('-----Setting Input------');

        if (window.canvasBlob === null) {
          console.log('----------DEBUG---------');
          console.log('--Canvas blob was null--');

          return;
        }

        console.log('----------DEBUG---------');
        console.log('--Canvas blob worked!---');

        const newProperty = document.createElement('input');

        newProperty.setAttribute('type', 'file');
        newProperty.classList.add('customily-hidden-property');
        newProperty.setAttribute('style', 'display:none !important;');
        newProperty.setAttribute('name', 'properties[Bekijk je personalisatie perview ->]');

        const fileName = `customilyPreview_${ Date.now() }.${ window.canvasBlob.type.split('/').pop() }`;
        const newFile = new File([window.canvasBlob], fileName, { type: window.canvasBlob.type });
        const dataTransfer = new DataTransfer();

        dataTransfer.items.add(newFile);

        const fileList = dataTransfer.files;

        newProperty.files = fileList;

        innerForm.insertAdjacentElement('beforeend', newProperty);

        return;
      }
    }
  };

  const observer = new MutationObserver(callback);

  observer.observe(productForm, config);
});

window.addEventListener('customily-starts-adding-to-cart', () => {
  console.log('----------DEBUG---------');
  console.log('--Starting add to cart--');

  const canvas = document.querySelector('#preview-canvas');

  if (!canvas) {
    console.log('----------DEBUG---------');
    console.log('----No canvas found-----');

    return;
  }

  console.log('----------DEBUG---------');
  console.log('------Setting blob------');

  canvas.toBlob(window.setCanvasBlob, 'image/jpeg', 1);
});

window.setCanvasBlob = (blob) => {
  window.canvasBlob = blob;
}
